// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__24FyR","dark":"Spinner_dark__O6p7Y"};